(() => {
  const popup = document.querySelector('[data-namtek-subscribe]');
  if (!popup || popup.dataset.initialized === 'true') return;
  popup.dataset.initialized = 'true';

  const panel = popup.querySelector('[data-namtek-subscribe-panel]');
  const closeButtons = popup.querySelectorAll('[data-namtek-subscribe-close]');
  const email = popup.querySelector('input[type="email"]');
  const form = popup.querySelector('form');
  const success = Boolean(popup.querySelector('[data-namtek-subscribe-success]'));
  const sessionKey = 'namtek-compact-subscribe-seen-v1';
  let previouslyFocused = null;

  const open = () => {
    previouslyFocused = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => popup.classList.add('is-open'));
    document.body.classList.add('namtek-subscribe-open');
    setTimeout(() => (email || panel)?.focus(), 360);
  };

  const close = () => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('namtek-subscribe-open');
    try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
    setTimeout(() => { popup.hidden = true; }, 320);
    previouslyFocused?.focus?.();
  };

  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
  });
  window.addEventListener('namtek:open-subscribe', open);
  form?.addEventListener('submit', () => {
    try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
  });

  let seen = false;
  try { seen = sessionStorage.getItem(sessionKey) === '1'; } catch (_) {}
  if (success || (popup.dataset.autoOpen === 'true' && !seen)) {
    setTimeout(open, success ? 150 : 1100);
  }
})();

